import type { BookTemplate } from "@lifescapsule/contracts";

export function BookMockup({
  template,
  name = "Eleanor",
}: {
  template: Pick<BookTemplate, "name" | "palette">;
  name?: string;
}) {
  return (
    <div className="book-scene" aria-hidden="true">
      <div className="book-shadow" />
      <div
        className="book"
        style={
          {
            "--book-cover": template.palette.cover,
            "--book-ink": template.palette.coverText,
            "--book-accent": template.palette.accent,
          } as React.CSSProperties
        }
      >
        <div className="book__spine" />
        <div
          className="book__cover"
          style={{ backgroundColor: template.palette.cover, color: template.palette.coverText }}
        >
          <span className="book__rule" />
          <small>A LIFE’S CAPSULE BOOK</small>
          <strong>{template.name}</strong>
          <span className="book__ornament" />
          <em>{name}</em>
          <span className="book__rule book__rule--bottom" />
        </div>
        <div className="book__pages" />
      </div>
    </div>
  );
}
